var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAkaswapSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "akaswap-small",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.803,
    height: 17.283,
    viewBox: "0 0 16.803 17.283",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_35",
    "data-name": "Group 35",
    transform: "translate(-55.303 -7.318)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M1456.858-124.879c1.145-1.473,2.129-2.749,3.122-4.015,3.195-4.071,6.4-8.13,9.579-12.217a1.531,1.531,0,0,1,1.409-.727c.878.056,1.762.014,2.693.014v17.265h-2.83v-14.008c-.393.474-.64.752-.867,1.05-2.979,3.914-5.97,7.817-8.918,11.76a1.771,1.771,0,0,1-1.712.895C1458.589-124.936,1457.834-124.879,1456.858-124.879Z",
    transform: "translate(-1401.555 149.16)",
    fill: "#3c3c3c"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAkaswapSmall);
export default __webpack_public_path__ + "static/media/akaswap_small.8c93ad47.svg";
export { ForwardRef as ReactComponent };